import React, { PropsWithChildren } from "react";
import { Message } from "../../adapters/insights-agent/state/AppState.ts";
import { Card } from "../../ui-library/Card/Card.tsx";
import { clx } from "../../utilities/clx.ts";
import { ActionBar } from "./ActionBar.tsx";
import styles from "./ChatMessages.module.css";

export const MessageBubble: React.FC<
  PropsWithChildren<{
    message: Message;
  }>
> = (props) => (
  <div
    className={`${styles.MessageContainer} ${props.message.sender === "agent" || props.message.sender === "system" ? styles.AlignLeft : styles.AlignRight}`}
  >
    <Card
      className={clx([
        props.message.sender === "agent" || props.message.sender === "system"
          ? styles.FromAgent
          : styles.FromUser,
        props.message.status === "optimistic" && styles.Optimistic,
        styles.MessageCard,
      ])}
    >
      {props.children}
    </Card>
    <ActionBar message={props.message} />
  </div>
);
